<template>
    <div class="mb-3">
        <Dropdown class="select w-100">
            <template #default>
                <div class="form-control cursor-pointer d-flex justify-content-start align-items-center">
                    <flag :country-code="activeLanguage.icon" v-if="activeLanguage"/>
                    <span v-if="valueProxy">{{ activeLanguage.name }}</span>
                    <span v-else>{{$t('profile.language_select')}}</span>
                    <fa-icon icon="chevron-down" class="ml-auto"/>
                </div>
            </template>
            <template #content="{closeMenu}">
                <div class="sidebar-light">
                    <ul class="nav nav-sidebar">
                        <li v-for="lang in supportedLanguages" :key="lang.value" class="nav-item">
                            <a class="nav-link cursor-pointer"
                               :class="{active: lang.value === valueProxy}"
                               @click="valueProxy = lang.value; closeMenu()"
                            >
                                <flag :country-code="lang.icon" /> {{ lang.name }}
                            </a>
                        </li>
                    </ul>
                </div>
            </template>
        </Dropdown>
    </div>
</template>

<script>
import Flag from "./Flag";
export default {
    name: "LanguageSelect",
    props: {
        value: String
    },
    components: { Flag },
    mounted() {
        this.initialValue = this.value
    },
    computed: {
        supportedLanguages: () => ([
            {name: 'Polski', value: 'pl', icon: 'pl'},
            {name: 'English', value: 'en', icon: 'gb'},
            {name: 'Pусский', value: 'ru', icon: 'ru'},
            {name: 'Український', value: 'ua', icon: 'ua'},
        ]),
        activeLanguage() {
            return this.supportedLanguages.find(lang => lang.value === this.valueProxy);
        },
        valueProxy: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    data: () => ({
        initialValue: String
    })
}
</script>

<style scoped>
</style>